import Model from './Model'
import User from './User'

export default class KintellGroup extends Model {
  resource () {
    return 'kintell-groups'
  }

  get link () {
    return '/g/' + this.slug
  }

  get membersPageLink () {
    return `/my-kintell/my-groups/members/${this.slug}`
  }

  get secondaryLogo () {
    return this.secondaryLogoUrl ? this.secondaryLogoUrl : this.logoUrl
  }

  // relations
  members () {
    return this.hasMany(User)
  }

  requestAccess (data) {
    return this.action('request-access', data)
  }

  approve (data) {
    return this.action('approve', data)
  }

  removeUser (userId) {
    return this.$http.$delete(this.resourceUrl() + `/remove/${userId}`)
  }

  join () {
    return this.action('join')
  }

  fetchMembers (pagination) {
    return KintellGroup
      .pagination(pagination)
      .custom(this, 'members')
      .$get()
  }
}
